import type { BecomeAdminCopy, BecomeAdminStep } from './types';

export const buildBecomeAdminSteps = (t: BecomeAdminCopy): BecomeAdminStep[] => [
  {
    id: 'company',
    title: t.becomeAdminStepCompany,
    description: t.becomeAdminStepCompanyDesc,
  },
  {
    id: 'representative',
    title: t.becomeAdminStepRepresentative,
    description: t.becomeAdminStepRepresentativeDesc,
  },
  {
    id: 'documents',
    title: t.becomeAdminStepDocuments,
    description: t.becomeAdminStepDocumentsDesc,
  },
];
